// Controlled vocab for clivage embryos. Set canónico (decisión 0025 / Q-060):
// MAYÚSCULAS — BE, BN, BX, BL, BI, MO, DG. El backend acepta input case-insensitive
// pero persiste/devuelve en mayúsculas; usamos mayúsculas como `value` para que el
// preload y el diff de edición cuadren con lo que trae el ensamblado (stages:{BL:2}).
//
// DG (degenerado) es especial (0025 §2): cuenta en embryos_count y en la suma de
// `stages`, pero NO genera embrión — se descarta y se reporta en `discarded`. MO
// (mórula) y todos los demás SÍ se persisten como embriones.
export const STAGES = [
    { value: 'BE', label: 'Blastocisto eclosionado', short: 'BE', color: '#15803d' },
    { value: 'BN', label: 'BN',                       short: 'BN', color: '#2f9e44' },
    { value: 'BX', label: 'Blastocisto expandido',    short: 'BX', color: '#66a80f' },
    { value: 'BL', label: 'Blastocisto',              short: 'BL', color: '#94a30d' },
    { value: 'BI', label: 'Blastocisto inicial',      short: 'BI', color: '#c77d0a' },
    { value: 'MO', label: 'Mórula',                   short: 'MO', color: '#0ea5b7' },
    { value: 'DG', label: 'Degenerado (descartado)',  short: 'DG', color: '#94a3b8', discard: true },
];

const STAGE_BY_VALUE = Object.fromEntries(STAGES.map(s => [s.value, s]));

// Lookup case-insensitive del color/etiqueta de un `stage` de embrión (la fuente
// la consume también transfers.js, para una sola paleta).
export function stageColor(code) {
    const s = STAGE_BY_VALUE[String(code || '').toUpperCase()];
    return s ? s.color : '#94a3b8';
}
export function stageLabel(code) {
    return String(code || '—').toUpperCase();
}

export const STORAGE = [
    { value: 'fresh',  label: 'Fresco' },
    { value: 'frozen', label: 'Congelado' },
];

export const PRESERVATION_METHODS = [
    { value: 'vitrification', label: 'Vitrificación' },
    { value: 'slow_freezing', label: 'Congelación lenta' },
];

// Single picker that resolves to the contract's { storage, method } preservation
// directive (decisions/0009 §4). Fresco = fresh (no method); the rest = frozen.
export const PRESERVATION = [
    { value: 'fresh',         label: 'Fresco',             storage: 'fresh',  method: null },
    { value: 'vitrification', label: 'Vitrificación',      storage: 'frozen', method: 'vitrification' },
    { value: 'slow_freezing', label: 'Congelación lenta',  storage: 'frozen', method: 'slow_freezing' },
];

export function preservationDirective(value) {
    const opt = PRESERVATION.find(p => p.value === value);
    if (!opt) return { storage: 'fresh' };
    return opt.method ? { storage: opt.storage, method: opt.method } : { storage: opt.storage };
}

// Σ de la distribución de stages → `embryos_count` (incluye DG; la suma de stages
// debe cuadrar con embryos_count, contrato admin-clivages.md).
export function stagesSum(stages) {
    return STAGES.reduce((acc, s) => acc + (Number(stages?.[s.value]) || 0), 0);
}

// Embriones realmente creados = Σ stages SIN DG (0025 §2: DG no genera embrión).
export function embryosCreated(stages) {
    return STAGES.reduce((acc, s) => acc + (s.discard ? 0 : (Number(stages?.[s.value]) || 0)), 0);
}

// Estructuras descartadas = Σ DG (lo que el backend reporta como `discarded`).
export function discardedCount(stages) {
    return STAGES.reduce((acc, s) => acc + (s.discard ? (Number(stages?.[s.value]) || 0) : 0), 0);
}

